import { matchPath } from 'react-router-dom';

export const checkIsActive = (current: string, href: string, routes: undefined|string[]): boolean => {
  if (current === href) return true;
  if (href && !!matchPath(href, current)) return true;
  if (routes && routes.findIndex(route => !!matchPath(route, current)) !== -1) return true;
  return false;
};
